import React from 'react';
import { withAppLayout } from '../core/routes';
import HomePage from './pages/HomePage';

export const homeRoutes = [{ path: '/', element: withAppLayout(<HomePage />) }];
